// extracted by mini-css-extract-plugin
export var animationContainer = "_o5-0";
export var footer = "_o5-1";
export var gray = "_o5-2";
export var lineItem = "_o5-3";
export var lineItemImage = "_o5-4";
export var lineItemInfo = "_o5-5";
export var lineItemText = "_o5-6";
export var lineItems = "_o5-7";
export var modalContent = "_o5-8";
export var options = "_o5-9";
export var orderName = "_o5-a";
export var refundAmount = "_o5-b";